import React from 'react'
import {Flex} from "./layout"
import ScrollTracker from '../kit/ScrollTracker'
import Overline from './_Overline'
import MilanVideos from './AboutMilanVideos'
import Plus from './_Plus'
import Superface from '../Superface'
import MenuItemSoon from './_MenuItemSoon'
    

class About extends React.Component{

    constructor(props){
        super(props)

        this.handleResize = this.handleResize.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
        this.handleScrollVirtual = this.handleScrollVirtual.bind(this)

    }

    componentDidMount(){
        
        this.container.addEventListener('scroll', this.handleScroll )
        Superface.setCompass('S')
        this.timeoutStartScroll = window.setTimeout( () => { 
            this.setState({ ...this.state, mounted : true });
            this.scroll.start()
            this.container.style.overflow = 'scroll'
            Superface.setLoading(false)
        }, 800 )

        window.addEventListener('resize', this.handleResize)
    }
    
    componentWillMount(){
        document.title = Superface.translate('Notre métier') + ' - Superface'
        this.setState({
            currentSectionIndex : 0,
            displayTopImages : true,
            showImageTopLeft : false,
            mounted : false,
            currentMilan : 1,
            shapeTextFixed : false,
            milanVideosFixed : false,
            milanVideosLeave : false,
            milanGalleryFixed : false,
        })
        this.scroll = new ScrollTracker()
        this.scroll.on( 'scroll', this.handleScrollVirtual )
    }
    
    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize)
        if( this.timeoutStartScroll ) window.clearTimeout( this.timeoutStartScroll )
        this.scroll.off( 'scroll', this.handleScrollVirtual )
        this.scroll.destroy()
    }

    handleResize(){
        this.setState({...this.state})
        this.handleScroll(null)
    }

    handleScroll(e){
        // console.log('sisisisisisisi')
        const MAIN_HEIGHT = 25 * window.innerHeight

        const scrollTop = this.container.scrollTop
        const overAllProgress = scrollTop / MAIN_HEIGHT * 100
        const BREAKS = [ 9, 13.98, 23.17, 28.09, 44.8, 50.2 ]
        
        switch( true ){
            case ( 
                overAllProgress < BREAKS[0] && 
                this.state.currentSectionIndex !== 0 ) :
                
                this.setState({
                    ...this.state,
                    currentSectionIndex : 0
                })
                break;

            case ( 
                overAllProgress >= BREAKS[0] && 
                overAllProgress < BREAKS[1] && 
                this.state.currentSectionIndex !== 1 ) :

                this.setState({
                    ...this.state,
                    currentSectionIndex : 1
                })
                break;

            case ( 
                overAllProgress >= BREAKS[1] && 
                overAllProgress < BREAKS[2] && 
                this.state.currentSectionIndex !== 2 ) :

                this.setState({
                    ...this.state,
                    currentSectionIndex : 2
                })
                break;
           
            case (
                overAllProgress >= BREAKS[2] && 
                overAllProgress < BREAKS[3] && 
                this.state.currentSectionIndex !== 3 ) :

                this.setState({
                    ...this.state,
                    currentSectionIndex : 3
                })
                break;

            case (
                overAllProgress >= BREAKS[3] && 
                overAllProgress < BREAKS[4] && 
                this.state.currentSectionIndex !== 4 ) :

                this.setState({
                    ...this.state,
                    currentSectionIndex : 4
                })
                break;
           
            case (
                overAllProgress >= BREAKS[4] && 
                overAllProgress < BREAKS[5] && 
                this.state.currentSectionIndex !== 5 ) :

                this.setState({
                    ...this.state,
                    currentSectionIndex : 5
                })
                break;
            
            case (
                overAllProgress >= BREAKS[5] && 
                this.state.currentSectionIndex !== 6 ) :

                this.setState({
                    ...this.state,
                    currentSectionIndex : 6
                })
                break;
            
            default:
                break;

        }
        
        if( 
            overAllProgress > 0.5 && !this.state.showImageTopLeft
        ){
            this.setState({ ...this.state, showImageTopLeft : true })
        }else if (
            overAllProgress < 0.5 && this.state.showImageTopLeft 
        ){
            this.setState({ ...this.state, showImageTopLeft : false })
        }
        
        /*=============================================
        =            SKILLS                           =
        =============================================*/
        
        if( 
            overAllProgress > 7 && overAllProgress <= 11 && !this.state.skillsFixed
        ){
            this.setState({ 
                ...this.state, 
                skillsFixed : true,
                displayTopImages : false
            })
        } else if( 
            overAllProgress > 11 && this.state.skillsFixed
        ){
            this.setState({ 
                ...this.state, 
                skillsFixed : false,
            })
        }else if (
            overAllProgress <= 7 && this.state.skillsFixed
        ){
            this.setState({ 
                ...this.state, 
                skillsFixed : false,
                displayTopImages : true
            })
        }

        /*=============================================
        =            SHAPES                           =
        =============================================*/

        if( 
            overAllProgress > 14 &&
            overAllProgress <= 20 &&
            !this.state.shapeTextFixed
        ){
            this.setState({ 
                ...this.state, 
                shapeTextFixed : true,
            })
        }else if ( 
            overAllProgress < 14 && 
            this.state.shapeTextFixed
        ){
            this.setState({ 
                ...this.state, 
                shapeTextFixed : false,
            })
        }else if (
            overAllProgress > 20 && 
            this.state.shapeTextFixed
        ){
            this.setState({ 
                ...this.state, 
                shapeTextFixed : false,
            })
        }

        if( overAllProgress > 9 && overAllProgress < 25 ){
            let progress = ( overAllProgress - 9 ) / 16
            let shapes_images = document.querySelectorAll('.shapes-image')
            shapes_images.forEach( (el, i) => {
                const q = ( i % 3 === 0 ) ? 0.8 : -1
                el.style.transform = 'translateY(' + ( progress * window.innerHeight * 2 * q ) + 'px)'
            });
        }

        
        /*=============================================
        =            MILANS VIDEO                     =
        =============================================*/

        if( 
            overAllProgress >= 19.4 &&
            overAllProgress < 21 &&
            !this.state.milanVideosFixed
        ){
            this.setState({ 
                ...this.state, 
                milanVideosFixed : true,
            })
        }else if ( 
            overAllProgress < 19.4 && 
            this.state.milanVideosFixed
        ){
            this.setState({ 
                ...this.state, 
                milanVideosFixed : false,
                milanVideosLeave : false
            })
        }else if (
            overAllProgress >= 21 && 
            this.state.milanVideosFixed
        ){
            this.setState({ 
                ...this.state, 
                milanVideosFixed : false,
                milanVideosLeave : true
            })
        }
        
        
        /*=============================================
        =            EXPERIENCE                       =
        =============================================*/
        

        if( overAllProgress > 21 && overAllProgress < 30 ){
            
            let progress = ( overAllProgress - 21 ) / 9
            let exp_images = document.querySelectorAll('.experience-image')
            exp_images.forEach( (el, i) => {
                let q
                switch(i){
                    case 0 :
                        q = 0.15;
                        break;
                    case 1 :
                        q = -0.06;
                        break;
                    case 2 :
                        q = 0.04;
                        break;
                    default :
                        q = -0.08;
                        break;
                }
                el.style.transform = 'translateY(' + ( progress * window.innerHeight * 2 * q ) + 'px)'
            });
            
        }

        /*=============================================
        =            GALERIE MILANS                   =
        =============================================*/

        if( 
            overAllProgress > 29.19 && overAllProgress <= 41.20 &&
            !this.state.milanGalleryFixed
        ){
            this.setState({ 
                ...this.state, 
                milanGalleryFixed : true
            })
        } else if ( 
            overAllProgress <= 29.19 && 
            this.state.milanGalleryFixed
        ){
            this.setState({ 
                ...this.state, 
                milanGalleryFixed : false
            })
        } else if (
            overAllProgress > 41.20 &&
            this.state.milanGalleryFixed
        ){
            this.setState({ 
                ...this.state, 
                milanGalleryFixed : false
            })
        }

        if( overAllProgress > 29.19 && overAllProgress < 44 ){
            let progress = ( overAllProgress - 29.19 ) / 5
            let imgs = document.querySelectorAll('.milan-image-container img')
            imgs.forEach( (img, i) => {
                if( i !== 0){
                    if( progress > i * 0.2 ){
                        img.style.display = 'block'
                    }else{
                        img.style.display = 'none'
                    }
                }
            })
        }
    }

    handleScrollVirtual(e){

        const ratio = this.scroll.positionY / ( window.innerHeight / 2 )
        
        if( ratio > 2.5 ){
            this.scroll.stop()
            this.container.style.overflow = 'hidden'
            Superface.goTo(Superface.uri('accueil'))
        }

    }

    render(){

        return(
            <div ref={ el => this.container = el } id="notre-metier" style={{backgroundColor:'white', width:'100vw', height:'100vh', overflow:'hidden'}}>
                
                {this.renderPageTitle()}
                {this.renderPage()}

            </div>
        )
        
    }

    renderPageTitle(){
        if( !this.props.about ) return
        const sectionName = Superface.field( this.props.about, 'section_title_' + ( this.state.currentSectionIndex + 1 ) )
        return(
            <div style={{
                position:'fixed', 
                top : '4.22rem', 
                width:'100vw', 
                textAlign : 'center', 
                zIndex:99,
                // mixBlendMode : (this.state.currentSectionIndex !== 4 ? 'initial' : 'difference')
            }}
                >
                {sectionName}
            </div>
        )
    }

    getSkillsStyle(){
        return {
            width:'100%',
            height:'100vh', 
            position: this.state.skillsFixed ? 'fixed' : 'absolute',
            top : this.state.skillsFixed ? 0 : '275vh',
            pointerEvents : 'none'
        }
    }

    getShapesTextStyle(){
        return {
            width:'100%', 
            height:'100vh', 
            position: this.state.shapeTextFixed ? 'fixed' : 'absolute',
            top : this.state.shapeTextFixed ? 0 : '350vh',
            pointerEvents : 'none'
        }
    }

    getMilanVideosStyle(){
        return {
            width:'100%', 
            height:'100vh', 
            pointerEvents : 'none',
            position: 'absolute', 
            zIndex:'98', 
            top : '480vh',
            backgroundColor : 'white'
        }
    }
    
    getMilanGalleryStyle(){
        return {
            width:'100%', 
            height:'100vh', 
            pointerEvents : 'none',
            position: this.state.milanGalleryFixed ? 'fixed' : 'absolute', 
            zIndex:'98', 
            top : this.state.milanGalleryFixed ? 0 : '730vh'
        }
    }

    renderPage(){
        const { about } = this.props
        const state = this.state
        const MAIN_HEIGHT = 25 * window.innerHeight

        const smallText = { fontSize : '1.2rem', margin : 'auto', maxWidth : '600px', width : '50%' }
        const largeText = { fontSize : '2.2rem', margin : 'auto', maxWidth : '600px', width : '50%' }
        const imagesTopStyle = { zIndex : 80, position : 'fixed' }

        if( about ){
            
            // console.log(about)

            return(
                <div style={{height: MAIN_HEIGHT * 0.51 }}>
                    
                    {/* TEXT TOP -------------------------------  */}
                    
                        <Flex className={'about-text-1 ' + ( this.state.mounted ? 'mounted' : '' )}  style={{position:'absolute', top : 0, bottom : 0, left:0, right:0 }} align="center" justify="center">
                            <div style={largeText} dangerouslySetInnerHTML={ this.crtmrkp( Superface.field(about, 'text_1')) } />
                        </Flex>

                        <div style={{ position : 'absolute', width:'100vw', top : '100vh' }}>
                            <div style={largeText} dangerouslySetInnerHTML={ this.crtmrkp( Superface.field(about, 'text_2')) } />
                        </div>

                    {/* IMAGES TOP -------------------------------  */}
                        <img
                            src={ Superface.assetUrl(about.image_1.path) } 
                            style={{ display : (state.displayTopImages ? 'block' : 'none'), width:'25vw', top:'30vh', right:'0', ...imagesTopStyle}} 
                            className={'image-top ' + ( this.state.mounted ? 'shown' : 'hidden' ) }
                            alt='Pièce de Milan'
                            />
                        
                        <img 
                            src={ Superface.assetUrl(about.image_2.path) } 
                            style={{ display : (state.displayTopImages ? 'block' : 'none'), height:'50vh', width:'auto', left:'-200px', top:'18vh', ...imagesTopStyle}} 
                            className={'image-top ' + ( this.state.showImageTopLeft ? 'shown' : 'hidden' )} 
                            alt='Pièce de Milan 2'
                            />
                        
                    {/* INTERSTICE -------------------------------  */}
                        <div 
                            style={{
                                width:'100vw', 
                                height: '100vh', 
                                clip: 'rect(0, auto, auto, 0)', 
                                left:0, 
                                position:'absolute', 
                                zIndex:100, 
                                top: '175vh'
                                }}>
                            <img
                                style={{
                                    width: ( window.innerWidth / window.innerHeight > 1.33 ) ? '100vw' : 'auto',
                                    height: ( window.innerWidth / window.innerHeight < 1.33 ) ? '100vh' : 'auto',
                                    position:'fixed', 
                                    top:'0' 
                                }} 
                                src={ Superface.assetUrl(about.interstice.path) }
                                alt='interstice'
                                />
                        </div>
     
                    {/* SKILLS -------------------------------  */}
                        
                        <Flex 
                            id="skills"
                            justify='center'
                            align='center'
                            style={this.getSkillsStyle()}
                            >

                            <Flex align='flex-start' justify='space-around' style={{width:'100%'}}>
                                
                                <Flex className='skill' direction='column'>
                                    <div>
                                        <h2>{Superface.field( about, 'titre_recherche')}</h2>
                                        <div dangerouslySetInnerHTML={this.crtmrkp( Superface.field( about, 'recherche'))} />
                                    </div>
                                    <br/>
                                    <div>
                                        <h2>{Superface.field( about, 'titre_proposition')}</h2>
                                        <div dangerouslySetInnerHTML={this.crtmrkp( Superface.field( about, 'proposition'))} />
                                    </div>
                                </Flex>
                                
                                <Flex className='skill' direction='column'>
                                    
                                    <div>
                                        <h2>{Superface.field( about, 'titre_developpement')}</h2>
                                        <div dangerouslySetInnerHTML={this.crtmrkp( Superface.field( about, 'developpement'))} />
                                    </div>
                                    <br/>
                                    <div>
                                        <h2>{Superface.field( about, 'titre_suivi')}</h2>
                                        <div dangerouslySetInnerHTML={this.crtmrkp( Superface.field( about, 'suivi'))} />
                                    </div>

                                </Flex>
                            </Flex>
                        </Flex>

                    {/* SHAPES -------------------------------  */}

                        <Flex 
                            id="shapes"
                            style={this.getShapesTextStyle()}
                            >

                            <div 
                                style={smallText} 
                                dangerouslySetInnerHTML={this.crtmrkp( Superface.field(about, 'text_4'))} 
                                className={(this.state.shapeTextFixed ? 'shapes-fixed' : '')}
                                />
                        
                        </Flex>   
                        
                        <div style={{position : 'relative', top : '310vh', zIndex : 50}}>

                            <img className='shapes-image' src={require('../images/galaxy-1.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/galaxy-2.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/milan-circle.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/galaxy-3.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/galaxy-4.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/galaxy-7.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/galaxy-8.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/galaxy-9.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/galaxy-10.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/galaxy-11.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/galaxy-12.svg')} alt="forme filaire"/>
                            <img className='shapes-image' src={require('../images/galaxy-13.svg')} alt="forme filaire"/>
                            
                        </div>

                    {/* 3DS -------------------------------  */}

                        <div
                            id="milans"
                            style={this.getMilanVideosStyle()}
                            >
                            
                            <Flex align="center" justify="space-around" style={{width:'80%', padding:'0 10%', position:'absolute', zIndex:10, bottom:'0'}}>
                                { this.renderObjLinks() }
                            </Flex>
                            
                            <Flex align="center" direction='column' justify="center" style={{width:'100%', height:'100vh', position:'absolute', zIndex:6, pointerEvents:'none'}}>
                                <MilanVideos about={about} current={ this.state.currentMilan } />
                            </Flex>

                        </div>

                    {/* EXPERIENCE -------------------------------  */}
                    
                        <Flex 
                            id="experience-text-1"
                            style={{position:'absolute', width:'100%', top:'610vh'}}
                            >
                            <div style={largeText} dangerouslySetInnerHTML={ this.crtmrkp( Superface.field( about, 'text_5'))} />
                        </Flex>
                        
                        <Flex 
                            id="experience-text-2"
                            style={{position:'absolute', width:'100%', top:'690vh'}}
                            >
                            <div style={smallText} dangerouslySetInnerHTML={ this.crtmrkp( Superface.field( about, 'text_6'))} />
                        </Flex>

                        <div style={{position : 'relative', top : '560vh', zIndex : 10}}>
                            <img className="experience-image" src={ Superface.assetUrl(about.image_4.path) } alt="notre experience" />
                            <img className='experience-image' src={ Superface.assetUrl(about.image_5.path) } alt="notre experience" />
                            <img className='experience-image' src={ Superface.assetUrl(about.image_6.path) } alt="notre experience" />
                            <img className='experience-image' src={ Superface.assetUrl(about.image_7.path) } alt="notre experience" />
                        </div>

                    

                    {/* IMAGES MILAN -------------------------------  */}
                    
                        <div id="images-milan" style={this.getMilanGalleryStyle()}>
                            <div style={{height:'100vh', position:'relative'}}>
                                {this.renderMilansImages(about.milans)}
                            </div>
                        </div>

                    {/* INTERSTICE MILAN -------------------------------  */}
                    
                        <div 
                            style={{
                                width:'100vw', 
                                height: '100vh', 
                                clip: 'rect(0, auto, auto, 0)', 
                                left:0, 
                                position:'absolute', 
                                zIndex:100, 
                                top: '1030vh'
                                }}>
                            <img
                                style={{
                                    width: ( window.innerWidth / window.innerHeight > 1.33 ) ? '100vw' : 'auto',
                                    height: ( window.innerWidth / window.innerHeight < 1.33 ) ? '100vh' : 'auto',
                                    position:'fixed', 
                                    top:'0' 
                                }} 
                                src={ Superface.assetUrl(this.props.about.milans[6].path) }
                                alt='Pièces de Milan interstice'
                                />
                        </div>
                    

                    {/* TEAM -------------------------------  */}
                    
                        <Flex 
                            direction="row-reverse"
                            align="center"
                            justify="center"
                            id="team"
                            style={{
                                height:'100vh', 
                                width:(window.innerWidth > 1280 ? '66%' : '70%' ), 
                                marginLeft: (window.innerWidth > 1280 ? '17%' : '15%' ), 
                                position:'absolute', 
                                top : '1130vh'
                            }}
                            >
                            {this.renderMembers(this.props.about.team)}
                        </Flex>
                    

                    {/* CONTACT -------------------------------  */}
                    
                        
                        <div 
                            id="contact"
                            style={{
                                position : 'absolute', top : '1290vh', width : '100%'
                            }}
                            >
                            <div style={{position:'relative'}}>

                                <div style={{...largeText, color:'black', position:'relative', zIndex:50}}>
                                    {Superface.field(this.props.about, 'text_merci' )}
                                    <br/>
                                    <br/>
                                   
                                    <p style={{fontSize:'1rem', lineHeight:'1.5rem', marginTop:'4vh'}}>
                                        {Superface.translate('Crédits :')}
                                        <br/>
                                        {Superface.translate('Direction artistique et site internet : ')}
                                        <a className="overline-link" href="https://www.bureaukayser.com/" target="_blank">
                                            <Overline>Bureau Kayser</Overline>
                                        </a>
                                        <br/>
                                        {Superface.translate('Photos : ')}
                                        <a className="overline-link" href="https://marvinleuvrey.com/" target="_blank">
                                            <Overline>Marvin Leuvrey</Overline>
                                        </a>
                                    </p>    

                                    <a target="_blank" href={this.props.contact.facebook} style={{ display:'inline-block', width:'2rem', marginLeft:'-0.5rem', marginTop:'5vh'}}>
                                        <img src={require('../images/facebook-black.svg')} alt="facebook"/>
                                    </a>
                                    &nbsp;&nbsp;
                                    <a target="_blank" href={this.props.contact.instagram} style={{ display:'inline-block', width:'2rem'}}>
                                        <img src={require('../images/instagram-black.svg')} alt="instagram"/>
                                    </a>

                                </div>
                                
                                <div style={{position:'realtive'}}>
                                    <div style={{position:'absolute', width:'15rem', left:'60%', bottom:'-20px', zIndex:'8'}}>
                                        <img src={require('../images/milan-circle.svg')} alt="Pièce de Milan"/>
                                    </div>
                                </div>

                               
                            </div>
                        
                        </div>
                            
                        <div style={{position:'absolute',top:'1350vh', width:'100%', height:'4rem', borderTop:'1px solid black'}}>
                            
                            <Flex justify="space-around">
                            
                                <div className="footer-link" style={{marginTop:0}}>
                                    <span className="overline-link" onClick={ () => { Superface.goTo( Superface.uri('contact') ) }}>
                                        <Overline>{ Superface.translate('Contact') }</Overline>
                                    </span>
                                </div>
    
                                <div className="footer-link" style={{marginTop:0}}>
                                    <span className="overline-link"  onClick={ () => { Superface.goTo( Superface.uri('matieres') ) }}>
                                        <Overline>{ Superface.translate('Matières') }</Overline>
                                    </span>
                                </div>
                                
                                <div className="footer-link" style={{marginTop:0}}>
                                    {/* <span className="overline-link" onClick={ () => { Superface.goTo( Superface.uri('projets') ) }}>
                                        <Overline>{ Superface.translate('Projets') }</Overline>
                                    </span> */}
                                    <MenuItemSoon display={Superface.translate('Projets')} style={{display:'inline-block'}} />
                                </div>
                            
                            </Flex>
                            
                        </div>

                </div>
            )
        }

    }
    
    renderObjLinks(){
        const a = [1,2,3,4,5,6]
        return(
            a.map( (n) => {
                return(
                    <Flex key={'milans'+n} style={{pointerEvents:'all', cursor:'pointer'}} direction="column" align="center" justify="center">
                        <div onClick={ () => { this.setState( {...this.state, currentMilan : n }) }} style={{width:"5vw"}} >
                            <img src={require('../images/superface_3D_' + n + '.png')} alt='Pièces de Milan 3d' />
                        </div>
                        <br/>
                        <Plus selected={ (this.state.currentMilan === n) }/>
                    </Flex>
                )       
            })        
        )
    }

    renderMembers(members){
        return members.map( (data, i) => {
            let member = { ...data.value }
            let style = {width: '33.3%', textAlign:'center', marginTop : '-0.6vw' }
            return(
                <div key={'member-'+i} className="member" style={style}>
                    <Flex direction="column" align="center">
                        
                        <div>
                            <img src={Superface.assetUrl(member.image.path)} alt={member.firstname + ' ' + member.lastname }/>
                        </div>

                        <div className="member-text">

                            <p style={{fontSize:'1.4rem', marginTop:'3rem'}}>
                                {member.firstname + ' ' + member.lastname}
                            </p>
                            
                            <p style={{fontSize:'0.9rem', marginTop:'1rem', minHeight:'3rem'}}>
                                {this.renderRoles(member)}
                            </p>

                        </div>

                    </Flex>
                </div>
            )
        })
    }

    renderRoles(member){
        if( Superface.app().lang === 'fr' ){
            return member.roles.map( (role,i) => <span style={{display:'block'}} key={'role_'+i} >{role}</span> )
        }else{
            return member.roles_en.map( (role,i) => <span style={{display:'block'}} key={'role_'+i} >{role}</span> )
        }
    }

    renderMilansImages(images){
        return (
            
            images.map( (img, i) => {

                if(i !== images.length - 1){
                    return(
                        <div key={'milan_images_'+i} className="milan-image-container">
                            <img className="milan-image"  ref={el => this['milan_image_'+i] = el } src={img.path} alt="Pièce de Milan"/>
                        </div>
                    )
                }else{
                    return
                }
                
            })
        )
    }

    crtmrkp(text){
        text = text.replace( /title="(.*)"/ , '');
        return { __html : text }
    }

}

export default About



// WEBPACK FOOTER //
// ./src/components/About.js